import { useEffect } from "react";

function useMessageBasedSubmissionDetection(validator, onDismiss) {
  useEffect(() => {
    if (!validator) return undefined;

    const isSubmitted = (data, validate) => {
      return validate.every(({ field, value }) => {
        return data[field] === value;
      });
    };

    const handleMessage = (event) => {
      const validate = validator?.[event.origin];

      if (!validate) return;
      if (typeof event.data !== "object" || event.data === null) return;

      if (isSubmitted(event.data, validate)) onDismiss();
    };

    window.addEventListener("message", handleMessage);

    return () => {
      return window.removeEventListener("message", handleMessage);
    };
  }, [validator, onDismiss]);
}

export default useMessageBasedSubmissionDetection;
